import type { Accessor } from "solid-js";
import { Group } from "~/components/ui/group";
import { Tabs, TabsContent } from "~/components/ui/tabs";
import { useDocumentContext } from "../../../providers/context";
import { DocumentBookmarksMobile } from "../Bookmarks/mobile";
import { SearchBar } from "../SearchBar";
import { DocumentToc } from "../Toc";
import { DocumentSidebarTabs } from "./tabs";

interface DocumentDesktopSidebarProps {
	height: Accessor<number>;
}

export function DocumentDesktopSidebar(props: DocumentDesktopSidebarProps) {
	const { tab, setTab } = useDocumentContext();

	return (
		<div class="col-span-4">
			<SearchBar />
			<Tabs
				value={tab()}
				onChange={setTab}
			>
				<Group class="mb-8">
					<DocumentSidebarTabs />
				</Group>
				<div
					class="min-h-[500px] h-[var(--height)] overflow-x-auto"
					style={{
						"--height": `${props.height()}px`,
					}}
				>
					<TabsContent value="toc">
						<DocumentToc screen="desktop" />
					</TabsContent>
					<TabsContent value="bookmarks">
						<DocumentBookmarksMobile />
					</TabsContent>
				</div>
			</Tabs>
		</div>
	);
}
